import classNames from 'classnames'
import Tracker from 'common/services/Tracker'
import * as React from 'react'
import Select from 'react-select'
import { DropdownItem } from 'ui/multi-product/constants'
import { TrackingKey } from 'even-ts-static'

const styles = require('./styles')
const ChevronDown = require('./chevron-down.svg')
const ChevronUp = require('./chevron-up.svg')

const CoverageAmountOptions: DropdownItem<unknown>[] = [
  { label: '$100,000', value: 100000 },
  { label: '$150,000', value: 150000 },
  { label: '$200,000', value: 200000 },
  { label: '$250,000', value: 250000 },
  { label: '$300,000', value: 300000 },
  { label: '$350,000', value: 350000 },
  { label: '$400,000', value: 400000 },
  { label: '$450,000', value: 450000 },
  { label: '$500,000', value: 500000 },
  { label: '$550,000', value: 550000 },
  { label: '$600,000', value: 600000 },
  { label: '$650,000', value: 650000 },
  { label: '$700,000', value: 700000 },
  { label: '$750,000', value: 750000 },
  { label: '$800,000', value: 800000 },
  { label: '$850,000', value: 850000 },
  { label: '$900,000', value: 900000 },
  { label: '$950,000', value: 950000 },
  { label: '$1,000,000', value: 1000000 },
  { label: '$1,250,000', value: 1250000 },
  { label: '$1,500,000', value: 1500000 },
  { label: '$1,750,000', value: 1750000 },
  { label: '$2,000,000', value: 2000000 },
  { label: '$2,250,000', value: 2250000 },
  { label: '$2,500,000', value: 2500000 },
  { label: '$2,750,000', value: 2750000 },
  { label: '$3,000,000', value: 3000000 },
  { label: '$3,250,000', value: 3250000 },
  { label: '$3,500,000', value: 3500000 },
  { label: '$3,750,000', value: 3750000 },
  { label: '$4,000,000', value: 4000000 },
  { label: '$4,250,000', value: 4250000 },
  { label: '$4,500,000', value: 4500000 },
  { label: '$4,750,000', value: 4750000 },
  { label: '$5,000,000', value: 5000000 },
]
const CoverageDurationOptions: DropdownItem<unknown>[] = [
  { label: '10 yrs', value: 10 },
  { label: '15 yrs', value: 15 },
  { label: '20 yrs', value: 20 },
  { label: '25 yrs', value: 25 },
  { label: '30 yrs', value: 30 },
  { label: '35 yrs', value: 35 },
  { label: '40 yrs', value: 40 },
]

interface OffersFilterProps {
  handleApplyFilters: (policyAmount: number, duration: number) => void
  onCoverageAmountChange: (value: number) => void
  onDurationChange: (value: number) => void
  coverageAmount: number
  coverageDuration: number
  isCollapsible: boolean
}

export const OffersFilter: React.FC<OffersFilterProps> = ({
  coverageAmount,
  coverageDuration,
  onCoverageAmountChange,
  onDurationChange,
  handleApplyFilters,
  isCollapsible,
}: OffersFilterProps) => {
  const [isCollapsed, setIsCollapsed] = React.useState(isCollapsible ? true : false)
  const [filterChanged, setFilterChanged] = React.useState(false)

  return (
    <div className={classNames(styles.offerFilterWrapper, isCollapsed ? styles.collapsed : styles.expanded)}>
      <div
        onClick={() => {
          if (isCollapsible) {
            setIsCollapsed(!isCollapsed)
          }
        }}
      >
        <h4>Adjust Coverage/Term</h4>
        {isCollapsible && isCollapsed && <ChevronDown className={styles.chevron} />}
        {isCollapsible && !isCollapsed && <ChevronUp className={styles.chevron} />}
      </div>
      <div data-testid="li-coverage-filter" className={styles.dropdownWrapper}>
        <label>Coverage Amount</label>
        <Select
          options={CoverageAmountOptions}
          className={styles.customSelect}
          placeholder={'$'}
          value={coverageAmount}
          onChange={(option) => {
            onCoverageAmountChange(option.value)
            setFilterChanged(true)
          }}
          clearable={false}
        />
      </div>

      <div data-testid="li-term-filter" className={styles.dropdownWrapper}>
        <label>Year Term</label>
        <Select
          options={CoverageDurationOptions}
          placeholder={'Yrs'}
          className={styles.customSelect}
          value={coverageDuration}
          onChange={(option) => {
            onDurationChange(option.value)
            setFilterChanged(true)
          }}
          clearable={false}
        />
      </div>

      <button
        data-testid="li-filter-apply"
        onClick={() => {
          Tracker.trackEvent({
            action: TrackingKey.LifeInsuranceOfferFilterApplied,
            data: { coverageAmount, coverageDuration },
            timestamp: new Date(),
          })
          handleApplyFilters(coverageAmount, coverageDuration)
        }}
        className={styles.applyBtn}
        disabled={!filterChanged}
      >
        Apply
      </button>
    </div>
  )
}
